module.exports = __webpack_public_path__ + "images/bookmark@2x.png?f6b337e9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bookmark@2x.png
// module id = 607
// module chunks = 7